import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import FormularioPlanPagos from "../../../components/PolizasEmitidasVigentes/PlanPagos/FormularioPlanPagos";
import { listarCiudadesFetch, listarProvinciasFetch } from "../../../redux/actions/aCotizacion";


class PlanesPagoPolizasEmitidas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.onChangeProvincia = this.onChangeProvincia.bind(this);
    }
    async componentDidMount() {
        await this.props.listarProvincias();
    }

    async onChangeProvincia(param) {
        await this.props.listarCiudades(param);
    }

    render() {
        return (
            <main className="bg-light">
                <div className="cr-content container-fluid">
                    <div className="container-body-spaces">
                        <FormularioPlanPagos
                            onChangeProvincia={this.onChangeProvincia}
                        />
                    </div>
                </div>
            </main>
        );
    }
}

const mapStateToProps = (state) => ({
    datosUsuario: state.datosUsuarios.dataUsuario
});

const mapDispatchToProps = (dispatch) => {
    return {
        listarProvincias: () => dispatch(listarProvinciasFetch()),
        listarCiudades: (provincia) => dispatch(listarCiudadesFetch(provincia)),
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(PlanesPagoPolizasEmitidas)
);